import {useEffect,useState} from 'react';
import {api,errMsg} from '@/lib/api';
import {useAuth} from '@/context/AuthContext';

export const ACTIVITY_CHANGED='tps-commerce-activities-changed';
export function useCommerceActivities(){
  const {user,studio,workspace}=useAuth();
  const key=`${user?.id}:${workspace?.scope?.studio_id||studio?.id}`;
  const owner=(workspace?.role||user?.role)==='studio_owner';
  const [state,setState]=useState({key:null,data:null,error:''}),[version,setVersion]=useState(0);
  useEffect(()=>{const update=()=>setVersion(v=>v+1);window.addEventListener(ACTIVITY_CHANGED,update);return()=>window.removeEventListener(ACTIVITY_CHANGED,update);},[]);
  useEffect(()=>{let active=true;if(!owner)return;
    api.get('/commerce/activities').then(data=>{if(active)setState({key,data,error:''});}).catch(e=>{if(active)setState({key,data:null,error:errMsg(e)});});
    return()=>{active=false;};
  },[key,owner,version]);
  return {data:owner&&state.key===key?state.data:null,error:owner&&state.key===key?state.error:'',refresh:()=>setVersion(v=>v+1),key};
}
